





















import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import { TreeSelect } from 'ant-design-vue';
// @ts-ignore
const { SHOW_PARENT } = TreeSelect;

@Component
export default class extends Mixins() {
  @Prop() value!: any;

  value1: any = [];

  treeData: any = [];

  SHOW_PARENT: any = SHOW_PARENT;

  @Watch('value')
  watchValue(val: any, oldVal: any) {
    if (val) {
      // console.log(val)
      this.value1 = val;
    }
  }

  async loadAreaTree() {
    const res = await this.$store.dispatch('api/getAreaTree', {});
    //   console.log(res)
    if (res && res.Data) {
      this.treeData = res.Data;
    }
  }

  mounted() {
    this.loadAreaTree().then(() => {
      if (this.value.length > 0) {
        this.value1 = this.value;
      }
    });
  }

  onChange(value: any) {
    this.value1 = value;
    this.$emit('change', value);
  }
}
